import { useEffect, useState } from "react";
// import { FaRegUserCircle } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { NoDataContent } from "../EmptyDataComponent/NoDataContent";
import { PDFDownloadLink } from "@react-pdf/renderer";
// import AdmitCard from "./AdmitCard";
import AdmitCard from "../sub-components/dashboard/AdmitCard";
import { formatDate } from "../../common/utils/formatData";

const TABLE_HEAD = [
  "Name",
  "Email",
  "Role",
  "Status",
  "SELECTION STATUS",
  "DOWNLOAD",
];

export const EventRegisteredUsers = () => {
  const { state } = useLocation();
  console.log("State", state);
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
  const [userList, setUserList] = useState(null);
  const [filter, setFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [unfilteredData, setUnfilteredData] = useState({
    users: [],
    pagination: {},
  });

  const navigate = useNavigate();

  const handleUnRegister = async (id) => {
    try {
      const accessToken = JSON.parse(
        window.localStorage.getItem("token")
      ).token;
      const response = await fetch(BASE_URL + `/api/eventregistrations/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/");
      }

      if (!response) {
        throw new Error("Network failure");
      }

      const data = await response.json();
      fetchUserList();
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleRegister = async (id) => {
    try {
      const accessToken = JSON.parse(
        window.localStorage.getItem("token")
      ).token;
      const response = await fetch(
        BASE_URL + "/api/eventregistrations/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            userId: id,
            eventId: state.id,
          }),
        }
      );
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/");
      }

      if (!response) {
        throw new Error("Network failure");
      }

      const data = await response.json();
      fetchUserList();
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleView = () => {};

  const fetchUserList = async () => {
    console.log("&&&&&& data from event card:", state.event);
    try {
      const accessToken = JSON.parse(
        window.localStorage.getItem("token")
      ).token;
      const response = await fetch(
        BASE_URL +
          "/api/eventregistrations/getusersforregistration/" +
          state.id,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/");
      }

      const { alreadyRegistered, notRegistered } = await response.json();
      let data = {
        users: [],
        pagination: [],
      };
      for (let i = 0; i < alreadyRegistered.length; i++) {
        data.users.push({ ...alreadyRegistered[i], registered: true });
      }
      for (let i in notRegistered) {
        data.users.push({ ...notRegistered[i], registered: false });
      }
      setUserList(data);
      console.log("###########", data);
      setUnfilteredData(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  useEffect(() => {
    if (!unfilteredData?.users?.length) {
      return;
    }
  
    const filteredUsers = unfilteredData.users
      .filter((user) => {
        if (filter === "registered") {
          return user.registered;
        } else if (filter === "notRegistered") {
          return !user.registered;
        } else {
          return true;
        }
      })
      .filter((user) => {
        const username = user.username || "";
        const email = user.email || "";
        const collegeName = user.collegeName || "";
        const registrationId = user.registrationId || "";
  
        return (
          username.toLowerCase().includes(searchTerm.toLowerCase()) ||
          email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          collegeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          registrationId.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
  
    setUserList({ users: filteredUsers });
  }, [filter, unfilteredData, searchTerm]);
  
  return (
    <section>
      <div className="bg-gray-50 sticky top-0 w-full py-4 flex justify-between items-center">
        <span className="ml-4 text-lg opacity-60 font-semibold">
          Student Registration List
        </span>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Search by name or email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="px-3 py-1 border rounded-md"
          />
          <button
            className={`px-3 py-1 text-sm border-2 shadow rounded-md transition duration-200
              ${
                filter === "all"
                  ? "bg-zinc-600 text-white border-zinc-600"
                  : "bg-white text-black border-zinc-600"
              }`}
            onClick={() => {
              setFilter("all");
            }}
          >
            All
          </button>
          <button
            className={`px-3 py-1 text-sm border-2 shadow rounded-md transition duration-200
              ${
                filter === "registered"
                  ? "bg-green-600 text-white border-green-600"
                  : "bg-white text-black border-green-600"
              }`}
            onClick={() => {
              setFilter("registered");
            }}
          >
            Registered
          </button>
          <button
            className={`px-3 py-1 text-sm border-2 shadow rounded-md transition duration-200
              ${
                filter === "notRegistered"
                  ? "bg-red-600 text-white border-red-600"
                  : "bg-white text-black border-red-600"
              }`}
            onClick={() => {
              setFilter("notRegistered");
            }}
          >
            Not Registered
          </button>
        </div>
      </div>
      {userList && userList.users.length > 0 ? (
        <table className="w-full text-left rounded overflow-hidden">
          <thead className="border-b-2 border-black border-opacity-20">
            <tr>
              {TABLE_HEAD.map((eachHead) => (
                <th key={eachHead} className="border-b border-blue-gray-50 p-4">
                  {eachHead}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {userList.users.map((eachRow) => (
              <tr key={eachRow.id}>
                <td className="p-4 border-b border-blue-50">
                  {eachRow.username}
                </td>
                <td className="p-4 border-b border-blue-50">
                  <span>{eachRow.email}</span>
                </td>
                <td className="p-4 border-b border-blue-50">
                  <span>{eachRow.role}</span>
                </td>

                <td className="p-4 border-b border-blue-50">
                  <button
                    onClick={() =>
                      eachRow.registered
                        ? handleUnRegister(eachRow.registrationId)
                        : handleRegister(eachRow.userId)
                    }
                    disabled={
                      eachRow.selectedForEvent
                        ? eachRow.selectedForEvent
                        : false
                    }
                    className={`p-2 pr-4 text-xs flex justify-center items-center ${
                      eachRow.registered
                        ? "bg-green-600 text-green-600"
                        : "bg-red-600 text-red-600"
                    } bg-opacity-40 hover:bg-opacity-50 duration-200 font-bold rounded`}
                  >
                    {eachRow.registered ? "Registered" : "Not Registered"}
                  </button>
                </td>
                <td className="p-4 border-b border-blue-50">
                  {eachRow.registered && (
                    <button
                      className={`p-2 pr-4 text-xs flex justify-center items-center ${
                        eachRow.selectedForEvent
                          ? "bg-yellow-700 text-white"
                          : "bg-red-600 text-red-600"
                      } bg-opacity-50 hover:bg-opacity-50 duration-200 font-bold rounded`}
                    >
                      {eachRow.selectedForEvent ? "SELECTED" : "PENDING.."}
                    </button>
                  )}
                </td>
                <td className="p-4 border-b border-blue-50">
                  {eachRow.selectedForEvent && (
                    <PDFDownloadLink
                      document={
                        <AdmitCard
                          userData={eachRow}
                          district={eachRow.district}
                          eventTitle={state.event.name}
                          date={formatDate(state.event.date)}
                          time={state.event.time}
                          registrationId={eachRow.registrationId}
                        />
                      }
                      fileName="Admission_Card.pdf"
                    >
                      {({ loading }) => (
                        <button
                          className="px-4 py-2 text-sm font-semibold text-white bg-blue-500 border border-blue-600 rounded-full shadow-md cursor-pointer transition-all duration-300 ease-in-out 
                            hover:bg-blue-700 hover:border-blue-600 hover:shadow-lg active:bg-blue-800 active:shadow-sm"
                        >
                          {loading ? "Generating PDF..." : "Admit Card"}
                        </button>
                      )}
                    </PDFDownloadLink>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <NoDataContent message="No students left for registration. Check back later!" />
      )}
    </section>
  );
};
